import { render, staticRenderFns } from "./ComparisonChart.vue?vue&type=template&id=72a8c67a&scoped=true&"
import script from "./ComparisonChart.vue?vue&type=script&lang=js&"
export * from "./ComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonChart.vue?vue&type=style&index=0&id=72a8c67a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a8c67a",
  null
  
)

export default component.exports